import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SpecimenStatementPage } from '@/features/zonalStatement/pages/SpecimenStatementPage';
import { zonalStatementSearchSchema } from '@/features/zonalStatement/types/zonalStatement.types';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute('/_auth/dashboards/zonal-statement/$userId/specimen')({
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  validateSearch: zonalStatementSearchSchema,
  component: function SpecimenStatementRoute() {
    const { userId } = Route.useParams();
    return (
      <ErrorBoundary moduleName="Specimen Statement">
        <Suspense fallback={<PageLoader />}>
          <SpecimenStatementPage userId={userId} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
